import script from "./AddToCart.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToCart.vue?vue&type=script&setup=true&lang=js"

import "./AddToCart.vue?vue&type=style&index=0&id=389ed6f0&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389ed6f0"]])

export default __exports__